import React from 'react';
import './Reset.css';
import './AllButtons.css';

export default function Reset({resetRoll, resetCurrentTotal, resetTurn, resetScores, togglePlay, newGame}) {
  function handleClick () {
    resetRoll();
    resetCurrentTotal();
    resetTurn();
    resetScores();
    togglePlay();
    newGame();
  }
  return (
    <>
    <button className="Button ResetButton" onClick={handleClick}>Reset Game</button>
    </>
  )
}
